import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from '../../utils/api';

const WhatsAppIcon = () => (
  <svg viewBox="0 0 32 32" fill="currentColor" className="h-7 w-7">
    <path d="M16.004 0h-.008C7.174 0 0 7.176 0 16c0 3.5 1.128 6.744 3.046 9.378L1.054 31.29l6.128-1.958A15.89 15.89 0 0016.004 32C24.826 32 32 24.822 32 16S24.826 0 16.004 0zm9.35 22.608c-.39 1.1-1.932 2.014-3.168 2.28-.846.18-1.95.324-5.668-1.218-4.762-1.972-7.826-6.814-8.064-7.13-.23-.316-1.932-2.574-1.932-4.91 0-2.336 1.222-3.482 1.656-3.96.39-.432.92-.626 1.23-.626.152 0 .288.008.41.014.434.02.652.046.938.726.358.852 1.228 3.006 1.334 3.226.108.22.216.518.068.818-.14.306-.264.496-.484.762-.22.266-.432.468-.652.754-.198.252-.422.522-.176.962.246.434 1.094 1.804 2.35 2.922 1.614 1.436 2.974 1.882 3.396 2.09.434.216.686.182.938-.108.258-.296 1.104-1.286 1.398-1.728.288-.434.582-.362.978-.216.4.144 2.538 1.198 2.972 1.416.434.22.724.324.832.504.106.182.106 1.048-.284 2.148z"/>
  </svg>
);

const WhatsAppButton = () => {
  const location = useLocation();
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.getWhatsAppSettings()
      .then(res => setSettings(res.data))
      .catch(() => {});
  }, []);

  // Hide on admin pages
  if (location.pathname.startsWith('/admin')) return null;

  // Don't render if settings not loaded, disabled, or no link
  if (!settings?.whatsapp_enabled || !settings?.whatsapp_link) return null;

  return (
    <a
      href={settings.whatsapp_link}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-20 left-6 z-50 group"
      data-testid="whatsapp-fab-button"
      aria-label="Chat on WhatsApp"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20 group-hover:opacity-30"></span>
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-all duration-300 hover:shadow-xl hover:scale-105 hover:bg-[#1EBE57]">
        <WhatsAppIcon />
      </span>
    </a>
  );
};

export default WhatsAppButton;
